'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toggleMask;
var TOGGLE_MASK_ACTION = exports.TOGGLE_MASK_ACTION = 'TOGGLE_MASK_ACTION';

function toggleMask(showMask) {
  return {
    type: TOGGLE_MASK_ACTION,
    showMask: showMask
  };
}


//////////////////
// WEBPACK FOOTER
// ./~/cw-ui-core/lib/components/mask/actions/ToggleMaskAction.js
// module id = 331
// module chunks = 10